import { render, staticRenderFns } from "./TransactionBackSite.vue?vue&type=template&id=5982adb6&scoped=true&"
import script from "./TransactionBackSite.vue?vue&type=script&lang=js&"
export * from "./TransactionBackSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5982adb6",
  null
  
)

export default component.exports